/* eslint-disable camelcase, css-modules/no-unused-class, no-nested-ternary  */
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsLeanUser, selectToken } from '@redux/slices/userSlice';
import { SmallLoader } from 'learning-panel-components';
import { coreService } from 'network-utils';
import { useGetTeamsLeaderboards } from '@queries/core/homepage';
import { translate } from 'translations';
import TeamLeaderboard from './teamLeaderbaord';
import styles from '../userLeaderboard/userLeaderboard.module.scss';

const TeamLeaderboardContainer: FC<{ searchString: string }> = ({ searchString }: { searchString: string }) => {
    const token = useSelector(selectToken);
    const isLeanUser = useSelector(selectIsLeanUser);
    const limit = 20;
    const [allTeams, setAllTeams] = useState<coreService.HomeTeamLeaderboard[]>([]);
    const [totalTeams, setTotalTeams] = useState<number>(0);
    const [offset, setOffset] = useState<number>(0);
    const [teamsOpenData, setTeamsOpenData] = useState<{ [teamId: string]: boolean }>({});
    const { isLoading: teamsLeaderboardIsLoading, data: teamsLeaderboardsData } = useGetTeamsLeaderboards(token, {
        search: searchString,
        offset: 0,
        limit,
        enableQuery: !isLeanUser
    });

    useEffect(() => {
        if (!teamsLeaderboardsData) return;
        if ((teamsLeaderboardsData as any).success === false) return;
        setAllTeams(teamsLeaderboardsData.teams);
        setTotalTeams(totalTeams);
    }, [teamsLeaderboardsData]);

    useEffect(() => {
        setOffset(0);
    }, [searchString]);

    const onLoadMore = () => {
        setOffset(offset + limit);
    };

    const onChangeOpenMode = (teamId: string, teamType: string) => {
        const myTeamsOpenDataTemp = { ...teamsOpenData };
        myTeamsOpenDataTemp[`${teamId}-${teamType}`] = !(
            Object.prototype.hasOwnProperty.call(myTeamsOpenDataTemp, `${teamId}-${teamType}`) &&
            myTeamsOpenDataTemp[`${teamId}-${teamType}`]
        );
        setTeamsOpenData({ ...myTeamsOpenDataTemp });
    };

    return totalTeams === 0 ? (
        <div className={styles['empty-state']}>
            <div className={styles.title}>{translate('noMatchingResults')}</div>
            <div className={styles['sub-title']}>{translate('TryUsingDifferentSearchWord')}</div>
        </div>
    ) : teamsLeaderboardIsLoading || allTeams.length === 0 ? (
        <SmallLoader size="100px" />
    ) : (
        allTeams && (
            <TeamLeaderboard
                onLoadMore={onLoadMore}
                hasMore={offset + limit < totalTeams}
                teams={allTeams}
                myTeams={[]}
                totalTeams={totalTeams}
                onChangeOpenMode={onChangeOpenMode}
                teamsUsersOpenState={teamsOpenData}
                searchString={searchString}
            />
        )
    );
};

export default TeamLeaderboardContainer;
